import './PracticePitcherSingleSessionPitchTypeRangesChart.scss';

import { PitchTypeRangesChartConfigDto, PitchTypeRangesChartDataDto } from 'types/CodegenReportTypes';

import { ChartProps } from 'utilities/chartIdToComponent';
import useReportStore from 'hooks/PracticeReport/PitcherSingle/reportStore';
import PitchTypeRangesChart from 'components/Charts/PitchTypeRangesChart/PitchTypeRangesChart';

const PracticePitcherSingleSessionPitchTypeRangesChart = (
  props: ChartProps<PitchTypeRangesChartDataDto, PitchTypeRangesChartConfigDto>
) => {
  const { selectedConfgValues } = useReportStore();

  return (
    <div className='PracticePitcherSingleSessionPitchTypeRangesChart-container'>
      <PitchTypeRangesChart {...props} pitchGrouping={selectedConfgValues.pitchGrouping} />
    </div>
  );
};

export default PracticePitcherSingleSessionPitchTypeRangesChart;
